import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import OffenceService from '@services/offence'

//Get Traffic divisions
export const getTrafficDivisions = createAsyncThunk('trafficDivisions/getTrafficDivisions', async (params) => {
  const response = await OffenceService.getTrafficDivisions(params)
  return { params, data: response.data, totalPages: response.meta.itemCount }
})

//Post new Traffic divisions
export const addTrafficDivisions = createAsyncThunk('trafficDivisions/addTrafficDivisions', async (inspectionPlaceData, { rejectWithValue }) => {
  try {
    const response = await OffenceService.addTrafficDivisions(inspectionPlaceData)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})
//Update Traffic divisions
export const updateTrafficDivisions = createAsyncThunk('trafficDivisions/updateTrafficDivisions', async (inspectionPlaceData) => {
  try {
    const reponse = await OffenceService.updateTrafficDivisions(inspectionPlaceData)
    return reponse
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})
//Delete Traffic divisions
export const deleteTrafficDivisions = createAsyncThunk('trafficDivisions/deleteTrafficDivisions', async (id, { getState, dispatch }) => {
  await OffenceService.deleteTrafficDivisions(id)
  await dispatch(getTrafficDivisions(getState()?.trafficDivisions?.params))
  return id
})
const TrafficDivisionsSlice = createSlice({
  name: 'trafficDivisions ',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: []
  },
  extraReducers(builder) {
    builder
      .addCase(getTrafficDivisions.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })

      .addCase(updateTrafficDivisions.fulfilled, (state, action) => {
        if (!action.payload?.id) {
          return
        }
        const { id } = action.payload
        const trafficDivisions = state.data.filter((trafficDivisions) => trafficDivisions.id !== id)
        state.data = [...trafficDivisions, action.payload]
      })
  }
})

export const selectTrafficDivisionsById = (state, id) => state.trafficDivisions.data.find((trafficDivisions) => trafficDivisions.id === id)
export default TrafficDivisionsSlice.reducer
